const notificationsModule = angular.module('app.notifications', ['commons.app']);
